import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Cateringterms = () => {


    const [currentTerms, setCurrentTerms] = useState(
        ' By using this application, you agree to comply with and be legally bound by these Terms and Conditions.'
    );
    const [newTerms, setNewTerms] = useState('');
    const [version, setVersion] = useState('1.2');
    const [lastUpdated, setLastUpdated] = useState('2025-04-04');
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => {
        setShowModal(false);
    };
    const usersAcceptance = [
        { name: 'Rahul', email: 'rahul@email.com', accepted: true, date: '2025-04-04', version: '1.2' },
        { name: 'Ram', email: 'ram@email.com', accepted: true, date: '2025-04-04', version: '1.2' },
    ];

    const handlePublish = () => {
        if (!newTerms.trim()) return alert('Terms cannot be empty');
        setCurrentTerms(newTerms);
        setVersion('1.3');
        setLastUpdated(new Date().toISOString().split('T')[0]);
        setNewTerms('');
        alert('New Terms Published');
    };

    const handleForceReaccept = () => {
        alert('All users will be required to re-accept the terms.');
    };


    const [selectedCustomer, setSelectedCustomer] = useState(null);





    const tabContent = {};
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-2'></div>
                <div className='col-lg-10'>
                    <p
                        className="breadcrumb maamaas-home-bredcum or15"
                        style={{
                            position: "fixed",
                            top: "80px",
                            left: "265px",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link
                                // to="/digitalmenu&billing"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Terms_Conditions
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Catering & Services

                        </span>
                    </p>
                    <div className='customer' style={{ overflowY: 'auto', height: '78vh', marginTop: '140px', scrollbarWidth: "none", }}>
                        {/* Tab Buttons */}
                        <div style={{ fontFamily: 'Arial' }}>
                            <h1 style={{ fontSize: '24px', fontWeight: 'bold' }}>Manage Terms & Conditions</h1>

                            <div style={cardStyle}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <h2 style={{ fontSize: '18px' }}>Current Terms (v{version})</h2>
                                    <span style={{ fontSize: '14px', color: 'gray' }}>Last Updated: {lastUpdated}</span>
                                </div>
                                <div style={{ marginTop: '10px', maxHeight: '200px', overflowY: 'scroll', backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '4px' }}>
                                    {currentTerms}
                                </div>
                            </div>

                            <div style={cardStyle}>
                                <h2 style={{ fontSize: '16px', marginBottom: '10px' }}>Edit & Publish New Terms</h2>
                                <textarea
                                    placeholder="Write new terms here..."
                                    value={newTerms}
                                    onChange={(e) => setNewTerms(e.target.value)}
                                    style={{ width: '100%', height: '120px', padding: '10px', fontSize: '14px', borderRadius: '4px' }}
                                />
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                    <button onClick={handlePublish} style={buttonStyle}>
                                        Publish Terms
                                    </button>
                                </div>

                            </div>

                            <div style={cardStyle}>
                                {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', }}>
                                    <h2 style={{ fontSize: '16px' }}>User Acceptance Tracker</h2>
                                    <button onClick={handleForceReaccept} style={dangerButtonStyle}>Force Re-Accept</button>
                                </div> */}
                                <div className='rrr2'>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#eee' }}>
                                                <th style={thStyle}>Name</th>
                                                <th style={thStyle}>Email</th>
                                                <th style={thStyle}>Accepted</th>
                                                <th style={thStyle}>Date</th>
                                                <th style={thStyle}>Version</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {usersAcceptance.map((user, idx) => (
                                                <tr key={idx}>
                                                    <td style={thTdStyle}>{user.name}</td>
                                                    <td style={thTdStyle}>{user.email}</td>
                                                    <td style={thTdStyle}>{user.accepted ? '✅ Yes' : '❌ No'}</td>
                                                    <td style={thTdStyle}>{user.date}</td>
                                                    <td style={thTdStyle}>{user.version}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>




                        {/* Modal */}
                        {selectedCustomer && (
                            <div style={modalOverlay}>
                                <div style={modalContent}>
                                    <h2 style={{ color: '#b15cd6' }}>Ticket Details</h2>
                                    <p><strong>ID:</strong> {selectedCustomer.id}</p>
                                    <p><strong>User:</strong> {selectedCustomer.user}</p>
                                    <p><strong>Subject:</strong> {selectedCustomer.subject}</p>
                                    <p><strong>Status:</strong> {selectedCustomer.status}</p>
                                    <p><strong>Assigned:</strong> {selectedCustomer.agent}</p>
                                    <p><strong>Priority:</strong> {selectedCustomer.priority}</p>
                                    <p><strong>Created:</strong> {selectedCustomer.created}</p>
                                    <button onClick={closeModal} style={{ marginTop: '20px', backgroundColor: '#b15cd6', border: 'none', color: 'white', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}>Close</button>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>

    );
};
const StatBox = ({ label, value }) => (
    <div className="stat-box">
        <div className="value">{value}</div>
        <div className="label">{label}</div>
    </div>
);



const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "5px",
    minWidth: "800px",
};

const thTdStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "center",
};

const thStyle = {
    ...thTdStyle,
    backgroundColor: "#b15cd6",
    fontWeight: "bold",
    color: "#fff"
};

const buttonStyle = {
    backgroundColor: "#b15cd6",
    border: "1px solid #000",
    textDecoration: "none",
    padding: "8px 10px",
    borderRadius: "20px",
    color: "#fff",
    cursor: "pointer",
    // textDecoration: "underline",
};

const modalOverlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const modalContent = {
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '10px',
    width: '400px',
    textAlign: 'left',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
};
const cardStyle = {
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    marginTop: '30px',
    borderRadius: '8px',
    // marginLeft:"-25px"
};



const dangerButtonStyle = {
    padding: '8px 16px',
    backgroundColor: '#d9534f',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
};

export default Cateringterms;
